/**
 * Viewer Instance Intra Module Communication
 * Commands, Requests, Events -- act with viewer context
 * State API -- commands, requests, subscriptions conduit -- forwarded through here
 * Outer Module Events forwarded through here
 */


var  _ = require('underscore'),
    fvChannel = require('glRadio').channel('FV'),
    OuterEventCallbacksByModule = require('./subscriptionCallbacks'),
    StateApi = require('../state/api'),
    StateCBs = require('../state/callback'),
    StateModel = require('../state/state'),
    CRE_Defaults = require('../creDownloadDefaults'),
    DownloadView = require('../../common/downloadFrame'),
    AjaxError = require('../../FV/error').ajaxError,
    Util = require('../../FV/util'),

    DeletePagesModal = require('../../dialogs/deletePages/view'),
    AddPagesModal = require('../../dialogs/addPage/view'),
    ReorderPagesModal = require('../../dialogs/reorderPages/view'),
    PageInfoModal = require('../../dialogs/pageinfo/view'),
    DocInfoModal = require('../../dialogs/docInfo/view'),
    AboutModal = require('../../dialogs/about/view'),

    PageFullSize = require('./../models/page/pgFullSize'),
    HiddenCanvasView = require('../../canvas/hiddenCanvas/view'),

    Backbone = require('backbone');

require('CRE');


//TODO: wrap in fn for caching
//TODO: all this.getSubApp -- replace with requestOn, commandOn

var requests = {

    // Document
    documents: function () {
        return this.documents;
    },
    activeDocument: function () {
        return this.activeDocument;
    },
    activeDocPages: function () { //nav /note -- these should be passed from local to gl
        return this.activeDocument.pageCollection;
    },
    activeDocHasNoPages: function () {
        return this.activeDocument.get('docHasNoPages');
    },
    activeDocumentTextModel: function() {
      return this.activeDocument.getDocumentTextModel();
    },

    //TODO: combo and clean ...

    //----------
    docHasSomeUnrenderablePgs: function () {
        return this.activeDocument.docHasSomeUnrenderablePgs();
    },
    docHasNoRenderablePgs: function () {
        return this.activeDocument.docHasNoRenderablePgs();
    },
    docHasRenderablePgs: function () {
        return this.activeDocument.hasRenderablePgs();
    },
    docHasNoPDFRenderablePgs: function() {
        return this.activeDocument.docHasNoPDFRenderablePgs();
    },
    docHasSomeUnrenderablePDFModePgs: function() {
        return this.activeDocument.docHasSomePDFRenderablePgs();
    },
    unrenderablePages: function () {
        return this.activeDocument.pageCollection.getUnrenderablePages();
    },
    unrenderablePDFModePgs: function () {
        return this.activeDocument.pageCollection.urlOrUnrenderablePages();
    },

    //------------

    allNotes: function () {
        return this.activeDocument.allNotes;
    },
    pageNotes: function () {
        return this.activeDocument.pgNotes;
    },
    docNotes: function () {
        return this.activeDocument.docNotes;
    },

    docIndexes: function () {
        return this.activeDocument.docIndexes();
    },
    fullTextModel: function () {
        return this.activeDocument.fullTextModel;
    },

    //settings ....
    settings: function () {  //TODO: only used in centerHeader, nav
        return this.settings;
    },
    imageFileType: function () {
        return this.settings.imageFileType();
    },
    excludePageNotes: function () { //only req'd in allNotes -- can rid after -- TODO: using?
        return this.settings.excludePageNotes();
    },
    fullTextQuery: function () {
        return this.settings.fullTextQuery();
    },
    //TODO: state?
    fullScreen: function () {
        return this.settings.fullScreen();
    },
    /* layout*/ //TODO: should never have to go through?
    getLayout: function () {
        return this.getSubApp('layout');
    },
    getWrapper: function () { //not the same as the container
        return this.requestOn('layout', 'wrapper');
    },
    modalView: function () {
        return this.requestOn('layout', 'modalView');
    },

    /* Note: this may not exist */
    docModeContainer: function () {
        return this.getSubApp('viewModes').getRegion('docModeContainer').currentView;
    },
    pgModeContainer: function () {
        return this.getSubApp('viewModes').getRegion('pgModeContainer').currentView;
    },
    pdfModeContainer: function () {
        return this.getSubApp('viewModes').getRegion('pdfContainer').currentView;
    },
    pdfWrapper: function () {
        return this.requestOn('viewModes', 'pdfWrapper');
    },
    //todo: really center header -- own module?
    getHeader: function () {
        return this.requestOn('layout', 'centerHeaderView');
    },
    //todo: rid -- access via channel
    rotateView: function () {
        return this.requestOn('layout', 'rotateView');
    },

    /*
     * Dynamic because container width can change ..
     * TODO: We may want to remove now.
     *  */
    getDocModeImgWidth: function () {

        var containerWidth = $(this.settings.el()).outerWidth(),
            MAX_DOC_WT = this.settings.maxDocWidth;

        return containerWidth < MAX_DOC_WT + 1
            ? containerWidth
            : MAX_DOC_WT;

    },

    /* note: could be doc or pg mode, now only supporting page */
    getAttributesToPersistOfNoteOnCanvas: function(note) {
        return this.requestOn( 'viewModes', 'getCanvasShapeAttrs', note, this.state.getCurrentScaleValue(), this.request('viewMode') );
    },
    //notes / canvas
    getCurrentDrawingAttributes: function () {
        return this.requestOn('notes', 'drawingAttributes');
    },

    //mediated here
    pageIsActivePage: function (page) { /* works page / thumb b/c relies on page number */
        return page.get('number') === this.state.currentPageNumber();
    },
    getPageFromThumbModel: function(thumb) {
        return this.activeDocument.pageCollection.at(thumb.collection.indexOf(thumb));
    },
    getPageModelFromNumber: function(pgNum) {
        return this.activeDocument.pageCollection.findWhere({
            number: pgNum
        });
    },

    /* Use to reference for page mode page models from that store on Doc Mode pages */
    getPagePositionalTextModel: function( pageNumber ) {
        return this.activeDocument.pageCollection.getPositionalTextModelOfPage( pageNumber );
    },

    pageHasPositionTextModel: function( pageNumber ) {
        var page = this.request('getPageModelFromNumber', pageNumber);
        return page.hasPositionalTextData();
    },

    // TODO: also check if instance of pgModel -- can determine in viewModes
    getThumbFromPageModel: function(page) {
        return this.activeDocument.thumbCollection.at( page.collection.indexOf(page) );
    },

    rotatePgRequest: function(deg) {

        var pg = this.state.currentPage(),
            doc =  this.request('activeDocument');

        if ( !doc.allowSaveRotation() ) {

            var newRotation = ( deg +  pg.get('rotation') ) % 360;

            /** Rotation always must be positive! ( -90 not allowed ); reflect logic used to store in page_info **/
            if ( newRotation < 0 ) {
                newRotation = newRotation + 360;
            }

            rotatePage.call( this, newRotation );

            return;
        }

        $.ajax({
            url: fvChannel.request('apiUrl').rotatePage( doc, pg.get('pageId'), deg ),
            type: 'PUT',
            context: this
        }).done( function(page) {

            rotatePage.call( this, page.rotation );

        }).fail(function (jqXHR) {

            this.command('ajaxError', jqXHR, 'Error rotating page');

        });

        function rotatePage( newPageRotation ) {

            /**
             * Document Mode --
             * A scale change event calls everything we need here ( updateViewPort, setVOffsets, checkPagesInview )
             * Ideally in future we have some sort of 'updateViewport' mechanism here (larger refactor)
             * TODO: update vOffsets on every scale change first
             * This is the only place scale is called on documentView not through the central fn,
             * so we need to ensure it exits.
             */
            pg.setRotation( newPageRotation );

            Util.blindForward(  this.state.get('documentViewScale'), 'setScale', pg, undefined , undefined, {
                byForce: 1,
                fromRotation: 1
            });

            /**
             * Thumbnails --
             * These don't currently have an 'updateViewport'ish equilent to set scale; should implement ...
             * Currently won't produce error if thumbnails module doesn't exist; but need to call if it doesn't.
             */

            if ( this.request('includeThumbnailsModule') ) {

                var thumb = this.request( 'getThumbFromPageModel', pg );
                thumb.setRotation( newPageRotation );
                doc.thumbCollection.setVOffsets();
                thumb.trigger('pageView:rotate');
                this.commandOn( 'thumbNails', 'checkInView' );
            }


            /**
             * Page Mode --
             * Scale change also updates rotation now, want an update viewport ....
             */
            var pageModePg = this.request('fullPageModel');
            pageModePg.setRotation( newPageRotation );
            this.state.get('pageViewScale').setScale( pageModePg , undefined , undefined , {
                byForce: 1,
                fromRotation: 1
            });

            /**
             * PDF MODE - can't call from in this mode --
             * set a flag so that when we re-enter, we make a new render request for the document
             */
            this.state.set( 'pdfRendered', false );

        }

    },
    // combo of doc and state props: use before calling load pdf
    allowPdfToLoad: function () {
        return this.activeDocument.shouldLoadPDF() && this.state.loadImages();
    },
    docModeScaleValues: function () {
        return this.settings.docModeScaleValues;
    },
    pageModeScaleValues: function () {
        return this.settings.pageModeScaleValues;
    },
    zoomIncrement: function () {
        return this.settings.zoomIncrement;
    },
    minScale: function () {
        return this.settings.minScale;
    },
    minImageScale: function () {
        return this.settings.MIN_IMG_SCALE;
    },
    minimumWidth: function () { //for layout resize ... combo with scale?
        return this.settings.minimumWidth;
    },
    maxNumberImgsToLoad: function () {
        return this.settings.MAX_NUM_IMAGES_TO_LOAD;
    },
    docModeImagesLoadingExceedsThreshold: function () {
        return this.request('numberImagesLoadingInDocMode') > this.request('maxNumberImgsToLoad') - 1;
        //todo: latter should come from the current viewer setting
    },
    getViewer: function () {
        return this;
    },
    /*
    * This doesn't mean scaling will not be applied to page views, just that the UI entry points will be blocked.
    * Applies to headerCenter (zoom views; hidden) and overflowHeader menu (zoom in/out; disabled).
    * */
    disableScaling: function () {

        var isPageMode = this.request('viewMode') === 'page',
            currentPage = this.request('currentPage');

        return  !this.state.loadImages() ||
                this.request('activeDocHasNoPages') ||
                ( isPageMode && !currentPage.isRenderable() ) ||
                ( isPageMode && currentPage.isGOS() && !currentPage.isGosHtmlFile() );

    },

    docOrPgModeCurrentPgEl: function () {
        return this.request('viewMode') === 'page'
            ? this.request('pgModeContainer').pageView.currentView.$el
            : this.getSubApp('viewModes').request('docModeViewOfPg', this.request('currentPage')).$el;
    },
    getDocRequest: function() {
        return this.aDocReq;
    },
    activeDocIndex: function() {
        return this.activeDocIndex;
    },

    getNewNoteModel: function( isDocNote, noteType ) {
        return this.requestOn('notes', 'getNewNoteModel', isDocNote, noteType );
    },

    /**
     * Create a new full page model ( from a clone of the document mode page ).
     * Always set wasRequested, isLoaded to false ( these can be requested multi-times ).
     */
    getNewFullPageModelFromDocModePage: function( page ) {

        return new PageFullSize( _.extend( _.clone(page.attributes), {
            wasRequested: false,
            isLoaded: false
        }), {
            parse: true,
            parentDocument: _.clone( page.get('parentDocument') ),
            imageFileType: page.get('imageFileType')
        });

    },

    // This is a hack for find and redact and floating codes, which need to be rendered to get their data to save ...
    // leave here for testing from console -- can prob remove later ...
    createHiddenPageCanvas: function( pageNumber, shapes ) {

        if ( this.dummyCanvasView )
            this.command( 'destroyHiddenCanvas' );

        this.dummyCanvasView = new HiddenCanvasView();
        this.dummyCanvasView.render( this.channel, pageNumber, shapes  );

        return this.dummyCanvasView;

    },

    /**
     * Now exists in the notes module; eventually we should 'lift' to the viewer level since shared
     * by notes and find and redact modules; it also makes things order dependent -- eg if want to disable
     * the F&R module in the layout header, this would need to be done prior to creation of this object
     * in the notes module. Could also give a centralized place for 'can redact'
     * as opposed to checking create page note task perm in createNewRedaction on entry.
     */
    getCreatableNotesHelper: function() {
        return this.getSubApp('notes').creatableNoteTypesHelper;
    },

    // --- perms ---
    allowDeletePages: function() {
        return this.request('activeDocument').allowDeletePages();
    },
    allowAddPages: function() {
        return this.request('activeDocument').allowAddPages();
    },
    allowReorderPages: function() {
        return this.request('activeDocument').allowReorderPages();
    },

    allowCreatePgNote: function() {
        return this.request('activeDocument').allowCreatePgNote();
    },
    allowCreateDocNote: function() {
        return this.request('activeDocument').allowCreateDocNote();
    },
    /*  same for document & page notes */
    allowModifyOrDeleteNote: function() {
        return this.request('activeDocument').allowModifyOrDeleteNote();
    },

    /* DVBC-1781 -- separate perm for highlight notes ( logic now: either user has it or create_page_note ) */
    allowCreateHighlight: function() {
        return this.request('activeDocument').allowCreateHighlight();
    },
    /* DVBC-1781 -- separate perm for highlight notes ( logic now: either user has it or delete_note ) */
    allowModifyOrDeleteHighlight: function() {
        return this.request('activeDocument').allowModifyOrDeleteHighlight();
    },

    /**
     * Determine the url required to load a PDF inside a iframe/window,
     * depending on the setting to use PDF.js.
     * Also takes into account whether to disable download buttons in PDF.js,
     * and potentially some other future settings.
     * Note: download & print permission now only required for test server.
     */
    getPdfUrlToLoadInFrame: function( creResponse ) {

        return this.request('usePdfJs')
            ? fvChannel.request('apiUrl').pdfJsViewer(
                    creResponse.inlineUrl,
                    this.request('allowDownload'),
                    fvChannel.request('user').canPrint(),
                    fvChannel.request('settings').isRunningNode
                )
            : creResponse.inlineUrl;

    },

    // Downloads / 'Exports'

    // Here implies ability to download/export the document
    allowDownload: function() {
        return fvChannel.request('user').canExport();
    },

    // Document part could be cached on parse ...
    allowDocumentDownload: function(isPDF) {
        return this.request('allowDownload') && this.request('activeDocument').isDownloadable(isPDF);
    },

    // May later combine setting to disable downloads (DVBC-1480).
    // Page is the page model; provide isPDF if want to download as PDF, otherwise raw.
    allowPageDownload: function(page, isPDF) {
        return this.request('allowDownload') && page.isDownloadable(isPDF);
    },

    allowPDFCombo: function() {
        return this.request('allowDownload') && this.request('documents').allowPDFCombo();
    },

    allowNewWindow: function() {
        return fvChannel.request('user').canExport();
    },

    // Not including permissions here -- that's handled in the notes module.
    // We should lift that logic atop here, especially since we don't need to make the note module standalone anymore
    allowCreationOfFullPageRedaction: function() {

        return !this.request('activeDocument').get('docHasNoPages') &&
            this.request('currentPage').allowCreationOfFullPageRedaction();
    },

    /**
     * No perms checks including in displaying the module ( create-pg-note, create-highlight ).
     * If user lacks ability to create any notes supported by F&R -- still show the module,
     * but disable the search.
     */
    includeFindAndRedactModule: function() {

        var settings = this.request('settings');
        var userProvidedSearches = settings.findAndRedact();
        var include = !settings.pdfOnly() && !settings.excludePageNotes();

        if ( userProvidedSearches ) {

            return include && this.request('activeDocument').hasPagesWithPositionalData();

        } else {

            return include && this.request('activeDocument').fddImagePagesExistAndAllHavePositionalData();
        }

    },

    /* Whether to include the module at all -- could cache for performance gains */
    includeThumbnailsModule: function() {
        return !this.request('settings').disableThumbs() && !this.request('activeDocHasNoPages');
    },

    /**
     * We never allow thumbnails in PDF mode ( DVBC-1817 ).
     * See callback.changeViewMode where the panel is closed if open on entry to pdf mode,
     * and headerLeft.toggleHeaderViewModeState.
     * DVBC-1823: separate from the inclusion of the module since it is no longer always created.
     */
    allowThumbnails: function() {
        return this.request( 'includeThumbnailsModule' ) && this.state.viewMode() !=='pdf';
    },

    /* View is still created if none exist, though it doesn't open automatically */
    includeIndexesModule: function () {
        return !this.settings.hideIndexes() && this.activeDocument.hasIndexes();
    },

    /**
     * DVBC-1823: for performance reasons, there are times we don't want to render the page views.
     * forShowingHeaderButton: we don't want to take whether the document has pages into account
     * ( only hide the button if the settings say so ).
     */
    includeDocumentMode: function( forShowingHeaderButton ) {

        var s = this.request('settings'),
            settingsAllow = !s.pdfOnly() && !s.singlePageOnly() && !s.disableDocMode();

        if ( !forShowingHeaderButton ) {
            return settingsAllow && !this.request('activeDocHasNoPages');
        }

        return settingsAllow;

    },

    // ALLOW: For time being a temporary flag until we decide how to handle these --
    allowDocumentLevelFullTextOverlayFunctionality: function() {

        var ALLOW = 0;

        if (PRODUCTION) {
            ALLOW = 0;
        }

        var settings = this.request('settings');

        // Note: excludePageNotes -- ocrNotes are not part of this collection; they are returned as pages.
        return ALLOW && this.request('activeDocument').hasPagesWithPositionalData() && !settings.pdfOnly();

    },

    allowDocumentLevelShowPageText: function() {
        return this.request('allowDocumentLevelFullTextOverlayFunctionality');
    },

    allowDocumentLevelTextOnlyMode: function() {
        return this.request('allowDocumentLevelFullTextOverlayFunctionality');
    },


    /* Really 'block access': page mode is always created */
    hidePageMode: function() {
        return this.request('settings').pdfOnly();
    },

    /* Really 'block access': pdf mode is always created */
    hidePdfMode: function() {
        return this.request('settings').singlePageOnly();
    },

    // Now only checking original download permission
    disableImageDownloads: function() {
        return !this.request('allowDownload');
    },

    // For now use PDF.js viewer is user lacks download or print permission
    usePdfJs: function() {

        var user = fvChannel.request('user');
        return !user.canExport() || !user.canPrint();

    }




};


var commands = {

    /* docIndex is the id from the documents collection or the direction of the doc nav btn click */
    changeActiveDoc: function(docIndex) {

        //var doc = this.documents.at(docIndex);
        //for now map the docReq array to the docIndexes -- todo: should the options be the same -- would be api change ... ?
        //var docReq = this.request('docRequest')[docIndex];

        if (typeof docIndex !== 'string') {

            this.activeDocIndex = docIndex;

        } else {

            var nDocs = this.documents.length - 1,
                isNext = docIndex === 'Next',
                isPrev = docIndex === 'Previous',
                isFirst = docIndex === 'First',
                isLast = docIndex === 'Last',
                isFirstDoc = this.activeDocIndex === 0,
                isLastDoc = this.activeDocIndex === nDocs;

            if ((isNext && isLastDoc) || (isPrev && isFirstDoc) || (isFirst && isFirstDoc) || (isLast && isLastDoc))
                return false;

            isNext && (this.activeDocIndex++);
            isPrev && (this.activeDocIndex--);
            isFirst && (this.activeDocIndex = 0);
            isLast && (this.activeDocIndex = nDocs);
        }

        // If an alert if open, close it before proceeding to the next document
        this.trigger('alert:hide');

        this._internalReset( {
            src: 'activeDocChange'
        });


    },

    /**
     * Renders a new page mode view (marionette region show) --
     * old lower level mediation applied here.
     * ... could clean this up further ...
     */
    createPageModeView: function(options) {

        if ( !this.activeDocument.hasPages() || !this.state.loadImages() )
            return;

        var fullPgModel = this.state.fullPageModel(),
            isPageMode = this.state.viewMode() ==='page',
            renderPgModeView = _.bind( function() {
                this.commandOn('viewModes', 'renderPgModePgView', fullPgModel);
            }, this);


        switch(options.src) {

            case 'pageChange':
                if (isPageMode) {
                    this.command('setScale');  // Still necessary?
                    renderPgModeView();
                }
                break;

            case 'viewerRendered':
                this.command('setScale'); // Ensure overflow settings applied
                isPageMode && renderPgModeView();
                break;

            // Note: could be triggered by active note change
            case 'modeChangeEntry':

                if (!isPageMode)
                    return;

                /**
                 * If loaded in other mode, would be hidden and scale wouldn't have been set
                 * (calculations of invisible dom item's -- do here.
                 * Also, set in case the layout updated and scale is fit height, fit width, auto ... (had loaded)
                 */
                this.command('setScale');

               // If wasn't loaded, create the new page view
               if ( !fullPgModel.get('isLoaded') )
                   renderPgModeView();

                break;


            case 'toggleLoadImages':
                isPageMode && renderPgModeView();
                break;
            }


    },

    ajaxError: AjaxError,

    /* Open in New Window Full Screen, Default Settings */
    openInNewWindow: function() {

        var template = require('../../dialogs/popup/popup.hbs')({
                docRequest:  JSON.stringify(  this.request('getDocRequest') ),
                instanceOptions:  Util.jsonStringyWithFunctions( _.omit(this.vOptions, 'el') ),
                fvOptions: Util.jsonStringyWithFunctions( fvChannel.request('options') ),
                js: __webpack_public_path__ + FV._src
            }),
            fvSettings = fvChannel.request('settings'),
            win = window.open('');

        /**
         * Since always a new window holding only the viewer,
         * utilize it's global namespace for action to hook into.
         * Currently used to set page rotation values that may be different if user lack save-rotation permission.
         * Ties into same hook as that set in viewer.reset
         * Could stringify/clone -- but fine since storing on the namespace (also see comments in reset if memory leaks become an issue)
         * */
        win[ fvSettings.NEW_WINDOW_NAMESPACE ] = {
            priorDocumentCollection: this.documents
        };

        win.document.open();
        win.document.write( template );
        win.document.close( fvSettings.PATH_TO_API );


    },

    /*
     * Open the active document as a PDF in a new browser tab.
     * May want to combo logic with download document or exportAllDocumentsAsPDF,
     * but don't want to mess w/and potentially break that code now ...
     */
    openDocAsPdfInNewWindow: function() {

        var activeDocument = this.request('activeDocument');

        /*
         * Functionality should be disabled in UI, but extra check here.
         * Note: implies document has pages and ones that renderable by CRE ( eg not multipart GOS )
         */
        if ( !activeDocument.hasRenderablePgs() )
            return;

        var creDefaultOpts = {
            isPDF: 1,
            inlinePDF: 1,
            vChannel: this.channel,
            completeCB: _.bind(function( creResponse ) {
                 window.open( this.request('getPdfUrlToLoadInFrame', creResponse) );
            }, this)
        };

        /*
         * ( file name escape so user can download from the PDF window )
         * also avoid current error if '/' for example in name; should revisit this
         */
        var creRequestOptions = _.extend( {},
            activeDocument.docRenderRequest( 'pdf', 'pdf' ), {
                fileName: activeDocument.documentName( activeDocument.getFileExtension(1), 1 )
            },
            new CRE_Defaults(creDefaultOpts)
        );

        $.fn.creRequest( creRequestOptions );
    },

    /*
    * Show the doc info dialog for the active document.
    * Re-request updated info mimicking a fetch of the active document
    * to ensure user lock and modified time are up-to-date.
    * Simpler than combining data from the existing activeDocument and another
    * web-service request to check the lock and mtime of the document (or anything else that could change).
    * Also -- note we're not updating the active document attributes whenever they are changed;
    * that would be a whole project that's currently unnecessary.
    * Note: no endpoint exists for a single document so utilize the endpoint for the collection.
    * */
    showDocInfo: function () {

        var docCollection = new this.documents.constructor();

        docCollection.fetch({
            docReq: [ this.request('activeDocument').getDocSlice() ],
            parse: false,
            context: this
        })
        .done( function() {

            this.trigger( 'modal:open', {
                modalView: new DocInfoModal({
                    docModel: docCollection.at(0)
                })
            });

        })
        .fail( function( jqXHR ) {
            this.command( 'ajaxError', jqXHR, 'Cannot Retrieve Data to Show Doc Info Dialog' );
        });

    },
    showPgInfo: function(page) {

        var isPDFMode = this.request('viewMode') === 'pdf';

        var modal = new PageInfoModal( _.extend( {}, {
            pages:
                !isPDFMode
                    ? ( page && page instanceof Backbone.Model ? page : this.request('currentPage') ) //former condition (a jq event could be sent)
                    : this.request('activeDocPages'),
            activeDocId: this.request('activeDocument').getId(),
            isPDFMode: isPDFMode

        }));

        this.trigger('modal:open', {
            modalView: modal
        });

    },
    showAbout: function () {

        var versionModel = fvChannel.request('versionModel');

        if ( !versionModel.wasFetched ) {

            versionModel.fetch( this )
                .done( showModal )
                .fail( function(errMsg) {
                    this.trigger('alert:show', {
                        type: 'error',
                        shortMessage: 'Unable To Load Version Data',
                        detailedMsg: errMsg
                    });
                });

            return;
        }

        showModal.call( this );

        function showModal() {

            this.trigger( 'modal:open', {
                modalView: new AboutModal({
                    versionModel: versionModel,
                    userModel: fvChannel.request('user'),
                    authModel: fvChannel.request('auth')
                })
            });
        }

    },
    /*
    * Called after viewer is loaded is  config option 'createNewRedactionOnEntry' true.
    * */
    createNewRedaction: function() {

        // First fail silently if the page is not annotatable
        if ( !this.request('currentPage').supportsAnnotation() )
            return;

        /**
         * Note: would like to centralize 'allowCreatePgNote' in notes.creatableNoteTypes helper.
         * But lifting it up to the viewer level would be a refactor that we can do later, if needed.  Here,
         * we could have a function on there allowRedactions, for this purpose.
         */
        if ( !this.request('allowCreatePgNote') ) {

            this.trigger('alert:show', {
                type: 'error',
                shortMessage: 'Unable To Create New Redaction',
                detailedMsg: 'User does not have necessary permissions to create a redaction.'
            });
            return;
        }

        this.commandOn('notes', 'createRedactionOnViewerLoad');

    },


   /**
    * Download Dispatcher
    *  Note: if document, pdf, and some pages aren't renderable, they won't be included
    *  pgNum is optional: if not provided, will be the current page
    */
    download: function(pageOrDoc, pdfOrRaw, pgNum) {

        var ad = this.activeDocument,
            isPDF = pdfOrRaw.toUpperCase() === 'PDF';

        pageOrDoc === 'document'
            ? downloadDocument.call( this, ad, isPDF )
            : downloadPage.call( this, pgNum ? this.request( 'getPageModelFromNumber', pgNum) : this.request('currentPage'), isPDF );


       // Note - for original downloads: if > 1 pages, CRE will return a zip of the individual pages.
       // If 1 page, will return just that page (we're setting this with the containerType param, set below).
       // However, for consistency with FDD, if downloading only one page, use the document name, not the page name (they can differ).
        function downloadDocument(doc, isPDF) {

            // Handle Document Downloads for For 1 Page Multi-Page-Gos Documents as
            // a page download of this type. ( Would never be PDF ).
            if ( ad.isOnePageMultiPartGosSkeleton() && !isPDF ) {
                downloadPage.call(this, ad.pageCollection.at(0) );
                return;
            }

            var nPages = doc.pageCollection.length,
                contType,
                pgType,
                options = {};

                if (!isPDF) {
                    // container type is 'zip' if > 1 page or 'raw' if just one page
                    contType = nPages === 1 ? 'raw' : 'zip';
                    pgType = 'raw';
                } else {
                    contType = 'pdf';
                    pgType = 'pdf';
                }

                // should name nonImageRenderReq / downloadRender req for clarity ...
                _.extend( options, doc.docRenderRequest( contType, pgType ), new CRE_Defaults({
                        isPDF: isPDF,
                        vChannel: this.channel
                    }),
                    { fileName: doc.documentName( doc.getFileExtension(isPDF), 1 ) }
                );

                $.fn.creRequest(options);
        }

        function downloadPage(pg, isPDF) {

            if ( ( pg.isGOS() || pg.isMultipartGosSkeleton() ) && !isPDF ) {

                // Browser file download
                // Note: currently no cookie to detect completion in the implementation (DVBC-1367)

                var dlView = new DownloadView({
                    src: pg.getRawDownloadUrl(),
                    container: this.request('getWrapper')
                }).render();

            } else {

                // Regular CRE render
                var type = isPDF ? 'pdf' : 'raw',
                    options = _.extend( {}, pg.nonImgRenderRequest(type, type), new CRE_Defaults({
                        isPDF: isPDF,
                        vChannel: this.channel
                    }), { fileName: pg.getPageName( isPDF ? 'pdf': undefined, 1 ) });

                $.fn.creRequest(options);
            }
        }

    },

    openPageInNewWindowAsPDF: function(page) {

        var opts =  _.extend( {}, page.nonImgRenderRequest('pdf', 'pdf'), new CRE_Defaults({
            isPDF: true,
            vChannel: this.channel,
            inlinePDF: 1,
            completeCB: _.bind( function(creResponse) {
                window.open( this.request('getPdfUrlToLoadInFrame', creResponse) );
            }, this )
        }), { fileName: page.getPageName( 'pdf', 1 ) });

        $.fn.creRequest(opts);

    },

    /* if popWindow, opens in new window, otherwise, downloads */
    exportAllDocumentsAsPDF: function(popWindow) {

        var creDefaultOpts = {
            isPDF: true,
            vChannel: this.channel
        };

        popWindow && _.extend( creDefaultOpts, {
            inlinePDF: 1,
            completeCB: _.bind(function(creResponse) {
                window.open( this.request('getPdfUrlToLoadInFrame', creResponse) ); // loading in the new window / block ui?
            }, this)
        });

        var opts = _.extend( {},
            this.documents.pdfRenderRequest(), {
                fileName: this.documents.pdfFileName()
            }, new CRE_Defaults(creDefaultOpts)
         );

        $.fn.creRequest(opts);
    },

    postToggleLeftSubPanel: function( pane ) {

        if ( pane.get('currentSubPane') === 'thumbs' ) {
            this.commandOn( 'thumbNails', 'checkInView' );
        }

    },

    /** Note: the module may not exist -- so commandOn */
    goToThumbnail: function( page ) {
        page = page || this.request('currentPage');
        this.commandOn( 'thumbNails', 'goToThumb', this.request('getThumbFromPageModel', page) );
    },

    //TODO: an outer event while still there
    togglePaneIsCoveringLayout: function(isCovering) { /*note: is reaction to change of state in layout */
        this.state.set({
            paneIsCoveringLayout: isCovering, /* need to fire so if opp panel is opened, the initial covering one is closed */
            loadImages: !isCovering
        });
    },

    pageImgLoadError: function(page) {

        if (page.typeIdentifier === 'THUMB')
            return;

        this.commandOn(['layout', 'notes'], 'pageImgLoadError', page);
    },

    // Quick fix until loading queue
    checkForDocModeImagesInView: function() {
        Util.blindForward(  this.request('docModeContainer'), 'checkForPagesInView' );
    },

    /**
     * TODO:
     * - should only be one entry point to requesting imgs
     * - later queue
     * Comes from page change and viewer load
     * Get current page, if prev, load prev, if next; also load next.
     * When goes to zero: the plugin will catch the current images on screen.
     */

    handleDocModeImgPrefetching: function(pg) {

        if ( !this.state.loadImages() || !this.request('includeDocumentMode') ) {
            return;
        }

        var prev = this.request('prevPage', pg),
            next = this.request('nextPage', pg);

        !pg.get('isLoaded') && pg.trigger('creRequest');

        next && !next.get('isLoaded') && next.trigger('creRequest'); // should create facade here
        prev && !prev.get('isLoaded') && prev.trigger('creRequest');


    },
    toggleMultiDocInterfaces: function(show) {
        this.command('mainView.toggleMultiDocInterfaces', show);
    },
    updatePostRunTimeError: function() {
        this.commandOn('layout', 'stopLoadingIndicator');
    },

    /**
     * Force close any dropdowns using jq plugin event.
     * Needed  propagation of a click event not allowed to reached the body level for some reason.
     * Could also put on $.fn.dropdown.closeAll
     */
    forceClosePageActionDropdownMenus: function() {
        this.view.$el.find('.dd-page-action-content').trigger('close');
    },


    //--- TODO: break apart into a pageOperations module/file ----

    // page is either a single page model or an array of them;
    // (want to move away from Backbone Collections towards ES6)
    deletePages: function(page) {

        this.activeDocument.deletePages( page instanceof Array ? page : [page] , this ).done( function( result ) {

            var pagesDeleted = result.successfulPages,
                errorPages = result.errorPages,
                nFailures = errorPages.length,
                nSuccesses = pagesDeleted.length,
                bAllSucceeded = nFailures < 1,
                bAllFailed = nSuccesses < 1,
                bAnySucceeded = nSuccesses > 0;

            //Note: alert is now at the top level view -- will remain shown throughout reloading of the document
            this.trigger('alert:show', {
                type: getMessageType(),
                shortMessage: getShortMessage(),
                detailedMsg: getDetailedMessage()
            } );

            // Don't reset document if all failed
            if ( bAnySucceeded ) {

                this._internalReset( {
                    src: 'pageDeleted'
                });
            }

            function getMessageType() {
                if (bAllSucceeded) return 'success';
                if (bAllFailed) return 'error';
                return 'info';
            }

            function getShortMessage() {
                if (bAllSucceeded) return (nSuccesses > 1 ? nSuccesses + ' ' : '') + 'Page' + (nSuccesses > 1 ? 's' : '') + ' Deleted';
                if (bAllFailed) return 'Error Deleting ' + (nFailures > 1 ? nFailures : '') + ' Page' + (nFailures > 1 ? 's' : '');
                return nSuccesses + ' Page' + (nSuccesses > 1 ? 's' : '') + ' Deleted. ' + 'Error Deleting ' + nFailures + ' Page' + (nFailures > 1 ? 's' : '');
            }

            function getDetailedMessage() {
                // decision made not to print the error messages, and to show page #'s, not id's or sequences

                if (bAllSucceeded)
                    return null;

               // Return the failed page numbers (of the current document at time of request) if all or some failed.
               // If all failed, the viewer won't reset and this will be good.
               // Potential improvement: if some failed include the old AND new pages # of the document;
               // This is such a fringe case that not doing now, given priorities

                return 'Failed to delete page' + (nFailures > 1 ? 's' : '') + ': ' + _.map(errorPages, function (p) {
                        return p.pageNumber;
                    }).join();

            }

        }).fail( function (jqXHR) {
            this.command('ajaxError', jqXHR, 'Error Deleting Pages');
        });

    },

    // If pgModel provided, show confirm to delete a single page.
    // Otherwise, show the Delete Pages Dialog.
    showDeletePageDialog: function( pgModel ) {

        if ( pgModel ) {

            this.trigger('modal:open', {
                confirmType: 'warning',
                title: 'Confirm',
                content: 'Delete Page ' + pgModel.get('number') + '?',
                okCB: _.bind( function() {
                    this.command( 'deletePages', pgModel);
                }, this )
            });

        } else {

            var pgs = this.request('activeDocPages');
            this.trigger('modal:open', {
                modalView: new DeletePagesModal({
                    numberPagesInDocument: pgs.length,
                    okCB: _.bind( function(aPgsNumbers) {

                        this.command( 'deletePages', typeof aPgsNumbers === 'string' && aPgsNumbers === 'currentPage'
                                ? this.request('currentPage')
                                : pgs.filter( function(p) {
                                return _.contains( aPgsNumbers, p.get('number') );
                            })
                        );

                    }, this)
                })
            });
        }

    },

    showAddPagesDialog: function() {

        var self = this;
        this.trigger('modal:open', {
            modalView: new AddPagesModal({

                    okCB: function(fileList, insertAtPgNum) {

                        self.activeDocument.addPages(fileList, insertAtPgNum).done( function(aPages) {

                            // Unlike delete page, entire transaction will either succeed/fail
                            var nPages = aPages.length;

                            self.trigger('alert:show', {
                                type: 'success',
                                shortMessage: nPages + (nPages > 1 ? ' Pages' : ' Page') + ' Added',
                            });

                            self._internalReset( {
                                src: 'pageAdded'
                            });

                        }).fail( function(jqXHR) {
                            self.command('ajaxError', jqXHR, 'Error Adding Pages.');
                        });

                    }
                })
        });
    },

    showReorderPagesDialog: function() {

        var self = this;

        this.trigger('modal:open', {
            modalView: new ReorderPagesModal({
                currentPgNumber: this.request('currentPageNumber'),
                numberPagesInDocument:  this.request('activeDocPages').length,

                okCB: function(pgsToMove, destinationPg, insertAfter) {

                    self.activeDocument.reorderPages.apply(self.activeDocument, arguments).done(function(aPages) {

                        // aPages:  array of pg objects already in order of their new sequence (slightly than obj's than pg model)

                        var nPages = pgsToMove.length;
                        self.trigger('alert:show', {
                            type: 'success',
                            shortMessage: nPages + (nPages > 1 ? ' Pages' : ' Page') + ' Reordered'
                        });

                        // Determine the page # to re-open to on reset -- it's what would be the new page number of the
                        // current page we're looking at (determined by page id).
                        // ( The viewer API expects page #, not id )
                        var currentPgId = self.request('currentPage').get('pageId'),
                            pgToOpenTo = _.findWhere( aPages, { pageId: currentPgId }),
                            pgNumToOpenTo = _.indexOf( aPages, pgToOpenTo ) + 1;  //(base 0 so add 1 -- like parse of page model collection)

                        self._internalReset( {
                            src: 'pageReordered',
                            pgNumberToOpenTo: pgNumToOpenTo
                        });

                    }).fail( function(jqXHR) {
                        self.command('ajaxError', jqXHR, 'Error Reordering Pages.');
                    });

                }
            })
        });

    },

    /*
    * Toggle the value in local storage.
    * Then re-render the shapes on the canvas, which will take updated value into account
    * (if the page has redactions).
    * */
    toggleApplyAllRedactionsInPageMode: function() {

        fvChannel.request('localStorage').toggleApplyAllRedactionsInPageMode();

        var currentPage = this.request('currentPage');

        // DVBC-1745 - former is a check in case document has no pages; the button
        // and hotkey will not be disabled.
        if ( currentPage && currentPage.hasRedactionNotes() )
            this.commandOn('viewModes', 'applyAllRedactionsToggled');


    },

    /*
     *  Central function that combines checking if the active document is locked,
     *  with actions to perform afterwards in the possible scenarios: locked, unlocked, error checking.
     *  ( So it's technically synchronous ).
     *  Action: required -- the name of the action to be performed to be displayed in dialogs -- eg: 'Create Note'
     *  unlockCB: required -- function to call if the document isn't locked.
     *  lockCB: optional -- function to call if the document is locked. Default is showing an alert (prevent the action).
     *  errorCB: optional -- function to call if error occurs hitting the endpoint.  Default is showing an alert (prevent the action).
     *  checkIfLockedByOtherUser -- default false: if provided return that the doc if locked, only if by another user.
     * */
    checkActiveDocLockStatus: function( action, unlockCB, lockCB, errorCB, checkIfLockedByOtherUser ) {

        var shortErrMsg = 'Cannot ' + Util.toTitleCase(action);

        this.request('activeDocument').checkLockStatus( this )
            .done( function( docLockResponse ) {

                var checkLockedFn = checkIfLockedByOtherUser
                    ? docLockResponse.isLockedByOtherUser
                    : docLockResponse.isLocked;

                if ( !checkLockedFn.call(docLockResponse) ) {
                    unlockCB.call(this, docLockResponse);

                } else {
                    lockCB
                        ? lockCB.call( this, docLockResponse )
                        : this.command( 'showDocumentLockedErrorAlert', shortErrMsg, docLockResponse ); // could combo with this.vChannel.command('ajaxError', jqXHR, 'Error deleting note') and have logic in there
                }

            })
            .fail( function( jqXHR ) {
                errorCB
                    ? errorCB.call(this, jqXHR )
                    : this.command( 'ajaxError', jqXHR, shortErrMsg );
            });
    },
    /*
    * Unlock the document if it was locked by this application.
    * No need to reset state.documentLockState ( viewer will not exist )
    * */
    unlockActiveDocumentBeforeUnload: function() {

        if ( this.state.isDocumentLockedByApplication() )
            this.request('activeDocument').unlockWithBeacon();

    },


    /*
    * Wrapper around alert dialog to show document locked by other user messages.
    * -- could combo with FV error 409 ???
    * */
    showDocumentLockedErrorAlert: function( shortErrMsg, docLockResponse ) {

        this.trigger( 'alert:show', {
            type: 'error',
            shortMessage: shortErrMsg,
            detailedMsg: docLockResponse.getDefaultErrorMessage()
        });
    },
    /**
     * Update layout after an 'element query resize event'
     * Should make this an event: but first should make the main view a subApp
     */
    updateAfterViewerResize: function() {

        if ( !this.request('viewerLoaded') )
            return;

        fvChannel.command('updateElementQuery');

        // better mediation ... ( if thumbs active, the module would need to exist )
        if (  this.getSubApp('layout').request('leftSideModel').isActivePane('thumbs') ) {
            this.commandOn( 'thumbNails', 'checkInView' );
        }

        this.trigger('vChannel:resizeSidesIfOverlap');
        this.command('setScale');

    },

    // This should be an event ... but I think I only have them as callback nows
    repositionShapeDialog: function() {
        this.commandOn( 'viewModes', 'repositionShapeDialog' );
    },

    /**
     * Called when user hits click or clears the F&R search.
     * Basically calls re-render of the canvas, which on render will reflect shapes from the f&r model.
     * For consistency, could put this in part of the state API / callback architecture but would like to move away from that.
     * Could reorganize and not have not store the model on the module and viewer state, but for now see now conflict requiring a refactor here
     * - not a big deal, share the same memory reference
     * - perhaps start it empty in the FT module and pass a new one for the viewer module
     * - though it could be the case the module doesn't exist
     * - * could also only ever reference from the full text module and not store on viewer state *
     * TODO: may want to lock/unlock the document if entering ...
     */
    setFindAndRedactSearchModel: function( searchModel ) {

        /* Update state with the model */
        this.state.set( 'findAndRedactSearchModel', searchModel );

        /* This would be the callback in the old state API arch */

        // -- Exiting: a 'clear' OR search with no results --
        if ( !searchModel.searchHasResults() ) {

            // Always clear the lock initially obtained when hit enter on search form --
            // If there are no results, immediately unlock ( user can't hit clear to unlock )
            // Also, this will unlock on a regular clear.
            this.command( 'unlockActiveDocument', 'FIND_AND_REDACT', 0, this, this.commands.updateToReflectFindAndRedactSearch );

        } else {

            /*  Entering: a search with results -*/
            this.trigger( 'vChannel:openToSubPane', this.request('getLayout').rightSideModel, 'notes' );
            this.command( 'updateToReflectFindAndRedactSearch' );

        }

    },

    /**
     * Can't just re-render -- need to call the wrapper on view modes ( see code ).
     */
    updateToReflectFindAndRedactSearch: function() {

        this.commandOn( 'viewModes', 'redrawCanvasForFindAndRedact', this.state.get( 'findAndRedactSearchModel') );

        /* Perhaps we want to highlight hits on a text layer in Doc Mode -- currently not doing ... maybe a phase II */
        /* -- using text overlay: createFindAndRedactHitViews  ---
         this.request('activeDocPages').each( function(page) {
         page.trigger('pageView:showFindAndRedactHits', hitsCollection)
         });
         // If not in the mode, it may not be created if haven't entered yet ... will need to be higher up to show on render of all pages
         this.request('fullPageModel').trigger('pageView:showFindAndRedactHits', hitsCollection);
         */

    },


    destroyHiddenCanvas: function() {

        this.dummyCanvasView && this.dummyCanvasView.destroy();
        this.dummyCanvasView = null;

    },

    /* Called on load and viewModeChange */
    setPageNavigationHotkeys: function( mode ) {

        mode = mode || this.request('viewMode');

        var docModeContainer = this.request('docModeContainer'),
            pgModeContainer = this.request('pgModeContainer');

        Util.blindForward( docModeContainer, 'unbindKeyboardEvents' );
        pgModeContainer.unbindKeyboardEvents();

        if ( mode === 'document' ) {
            Util.blindForward( docModeContainer, 'bindKeyboardEvents' );
        }

        else if ( mode === 'page' ) {
            pgModeContainer.bindKeyboardEvents();
        }

    }


};

/* ViewerState needed to set context of forward state callbacks */
var ViewerChannelElements = function(viewerState) {
    this.requests = requests;
    this.commands = commands;
    this.stateApi = new StateApi();
    /* AUTO-FORWARD STATE FNS TO CHANNEL (also puts them on the channel */
    extendAndforwardFunctions(this.requests, this.stateApi.requests, viewerState); /* merge API requests with channel requests, and make context of each the viewer state) */
    extendAndforwardFunctions(this.commands, this.stateApi.commands, viewerState);
    /* done for outer module, events, state model events (including scaleModel) */
    /* generate subscriptions from the outerEvents and corresponding outerEvents callbacks that the channel will listen to*/
    this.subscriptions = generateSubscriptions();
    //todo: destroy
};

/* target: where to forward the fn, fnHash: 'key-value' of 'fnName': fn, context : that to call the fn */
function extendAndforwardFunctions(target, fnHash, cxt) { //todo: util
    _.each( _.pairs(fnHash), function(fn) {
        var fnName = fn[0];
        target[fnName] = function() {
            return fn[1].apply(cxt, arguments);
        };
    });
}


/* the hash of event-cb */

//todo: if getting rid of the cb hash -- the events listened for outside subs aren't prefaced by the event name -- tha is why had hash
// could use naming scheme
//these are then added to the viewer channel subscriptions
function generateSubscriptions() {
    var hookCBs = function (eventHash, callbacks) {
            var hooks = {};
            for (var k in eventHash) { //careful w/fns
                hooks[k] = callbacks[eventHash[k]];
            }
            return hooks;
        },

        categoriedCBHash = OuterEventCallbacksByModule,
        categories = _.keys(categoriedCBHash),
        allHooks = {};


    /* outer subscription cbs -- fmt: evt 'alert:show' --> alertShow -- the actual used */
    _.each(categories, function(c) {
        var catCBs = categoriedCBHash[c];
        _.each(catCBs, function(cbFn, cbName) {
            var h = {};
            h[cbName] = cbFn;
            _.extend(allHooks, h);
        });

    });

    /* state: just put in same file? */
    _.extend(allHooks,
        hookCBs(StateModel.prototype.events, StateCBs),
        hookCBs(StateModel.prototype.scaleEvents, StateCBs)); //actually bind events to callbacks of vm

    return allHooks; //want obj
}


module.exports = ViewerChannelElements;



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/channel/channel.js
 ** module id = 104
 ** module chunks = 0
 **/